import { Component, signal, ViewChild } from '@angular/core';
import { Section } from '@mira-avant/mtlibs';
import { AngularModule } from '../../../modules/angular.module';
import { ZorroModule } from '../../../modules/zorro.module';
import { JourneySectionSelectorComponent } from '../../ui/journey/journey-section-selector/journey-section-selector.component';
import { HeaderComponent } from '../../ui/journey/header/header.component';
import { PageBoxComponent } from '../../ui/journey/page-box/page-box.component';
import { CourseTitleComponent } from '../../ui/journey/course-title/course-title.component';
import { ClientService } from '../../../services/client.service';
import { SectionSelfRoster } from '../../ui/section-self-roster/section-self-roster';
import { QuickEnroll } from '../../ui/quick-enroll/quick-enroll';
import { NavigationService } from '../../../services/navigation.service';

@Component({
	selector: 'app-section-selection',
	standalone: true,
	imports: [
		AngularModule,
		ZorroModule,
		JourneySectionSelectorComponent,
		HeaderComponent,
		PageBoxComponent,
		CourseTitleComponent,
		SectionSelfRoster,
		QuickEnroll,
	],
	templateUrl: './section-selection.component.html',
	styleUrl: './section-selection.component.scss',
})
export class SectionSelectionComponent {
	@ViewChild('selector') selector: JourneySectionSelectorComponent | undefined;

	sections = signal<Section[]>([]);
	isSelfRosteringAllowed = signal(false);

	constructor(
		private nav: NavigationService,
		private clientService: ClientService
	) {
		this.loadSelfRosterStatus();
	}

	private async loadSelfRosterStatus() {
		const allowed = await this.clientService.isSelfRosteringAllowed$();
		this.isSelfRosteringAllowed.set(allowed);
	}

	public onSectionsLoaded(sections: Section[]): void {
		this.sections.set(sections);
	}

	public onSectionSelected(section: Section): void {
		this.nav.navigateWithMatrix$(
			['/', 'my', 'journey'],
			{
				sectionUuid: section.uuid,
				courseUuid: section.course_uuid,
				locationUuid: section.location_uuid,
			},
			false
		);
	}
}
